import { Box, CircularProgress, Modal } from '@mui/material'

const PdfLoader = ({open}) => {
  return (
    <Modal open={open}>
        <Box sx={{width:'100vw',height:'100vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
        <CircularProgress color='success'/>
        </Box>
    </Modal>
  )
}

export default PdfLoader;